import {
  calculateBinaryWinnerProbabilities,
  calculateUplift,
  calculateVariantExtraTransactions,
} from './reportAnalysisUtils';

/** Build DataGrid rows from analysis object (control + variants) */
export function buildVariantGridRows(originalData, analysis) {
  if (!analysis?.control) return [];

  const binaryWinnerProbabilities = calculateBinaryWinnerProbabilities(analysis);
  const testDuration = originalData.testDuration || originalData.analysis?.testDuration || null;

  const getBinaryWinnerProbability = (variantName) => {
    if (!binaryWinnerProbabilities) return 0;
    const binaryResult = binaryWinnerProbabilities.find(
      (result) => result.variantName === variantName,
    );
    return binaryResult ? binaryResult.variantWinProbability * 100 : 0;
  };

  const controlSignificance = (() => {
    if (!binaryWinnerProbabilities?.length) return 0;
    const avgControlWinProb =
      binaryWinnerProbabilities.reduce((sum, result) => sum + result.controlWinProbability, 0) /
      binaryWinnerProbabilities.length;
    return avgControlWinProb * 100;
  })();

  const buildRow = (variant, variantName, uplift, winnerProbability, isControl = false) => {
    const extraTransactions = isControl
      ? null
      : calculateVariantExtraTransactions(
          {
            conversions: variant.conversions || 0,
            sessions: variant.sessions || 0,
          },
          {
            conversions: analysis.control.conversions || 0,
            sessions: analysis.control.sessions || 0,
          },
          testDuration,
        );

    return {
      id: variantName,
      variant: variantName,
      sessions: variant.sessions || 0,
      conversions: variant.conversions || 0,
      cr: variant.cr || 0,
      uplift: isControl ? null : uplift,
      significance: isControl ? controlSignificance : winnerProbability,
      monthly: extraTransactions?.monthlyExtraTransactions ?? null,
      yearly: extraTransactions?.yearlyExtraTransactions ?? null,
      isControl,
    };
  };

  const rows = [
    buildRow(
      analysis.control,
      analysis.control.name || 'Kontrol',
      null,
      controlSignificance,
      true,
    ),
  ];

  if (analysis.variants && Array.isArray(analysis.variants)) {
    analysis.variants.forEach((variant, index) => {
      if (!variant) return;

      const variantName = variant.name || `Varyasyon ${index + 1}`;
      const winnerProbability = getBinaryWinnerProbability(variantName);
      const uplift =
        variant.improvement !== undefined && variant.improvement !== null
          ? variant.improvement
          : calculateUplift(variant.cr || 0, analysis.control.cr || 0);

      rows.push(buildRow(variant, variantName, uplift, winnerProbability));
    });
  } else if (analysis.variant) {
    const variantName = analysis.variant.name || 'Varyasyon 1';
    const winnerProbability = getBinaryWinnerProbability(variantName);
    const uplift =
      analysis.improvement !== undefined && analysis.improvement !== null
        ? analysis.improvement
        : calculateUplift(analysis.variant.cr || 0, analysis.control.cr || 0);

    rows.push(buildRow(analysis.variant, variantName, uplift, winnerProbability));
  }

  return rows;
}
